import React from 'react'
import './LoadingCell.css'

export default class LoadingCell extends React.Component {

  shouldComponentUpdate(nextProps) {
    return nextProps.index !== this.props.index
  }

  render() {
    const width = Math.round(Math.random() * 100);
    return <span className="loading-cell" style={{width: `${width}%`}}></span>
  }
}


// WEBPACK FOOTER //
// ./src/components/Generic/LoadingCell.js